import React, {useMemo} from 'react';
import QuestionMultiSelector from '../components/MultiSelector';
import {EConditionDisplay, MultiSelectorQuestion} from '../types/question';

const QuestionSevenVehicleFeaturesLong = (props: MultiSelectorQuestion) => {
  const {title, multiSelectOptions, nextStepId, result, subHeading} = props;
  const displayOptions = useMemo(() => {
    if (result) {
      if (
        result.q3_vehicle_use &&
        typeof result.q3_vehicle_use === 'string' &&
        (result.q3_vehicle_use.includes('trade') ||
          result.q3_vehicle_use.includes('transporting_goods'))
      ) {
        return multiSelectOptions.filter(
          (option) => option.type !== EConditionDisplay.DISPLAY,
        );
      } else if (
        result.q4_passengers &&
        (result.q4_passengers === 6 || result.q4_passengers === 7)
      )
        return multiSelectOptions.filter(
          (option) => option.type !== EConditionDisplay.DISPLAY,
        );
      else {
        return multiSelectOptions.filter(
          (option) => option.type !== EConditionDisplay.HIDDEN,
        );
      }
    }

    return multiSelectOptions;
  }, [multiSelectOptions, result]);
  return (
    <QuestionMultiSelector
      subHeading={subHeading ?? ''}
      multiSelectOptions={displayOptions}
      title={title || ''}
      nextStepId={nextStepId}
    />
  );
};

export default QuestionSevenVehicleFeaturesLong;
